import axios from "axios";
import { base_url } from "../../../utils/baseUrl";
import { config } from "../../../utils/axiosconfig";

const getMenus = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const url = queryString 
    ? `${base_url}cms/menus?${queryString}`
    : `${base_url}cms/menus`;
  const response = await axios.get(url);
  return response.data;
};

const getMenu = async (id) => {
  const response = await axios.get(`${base_url}cms/menus/${id}`, config);
  return response.data;
};

const getMenuByLocation = async (location) => {
  const response = await axios.get(`${base_url}cms/menus/location/${location}`);
  return response.data;
};

const createMenu = async (menuData) => {
  const response = await axios.post(`${base_url}cms/menus`, menuData, config);
  return response.data;
};

const updateMenu = async (id, menuData) => {
  const response = await axios.put(
    `${base_url}cms/menus/${id}`,
    menuData,
    config
  );
  return response.data;
};

const deleteMenu = async (id) => {
  const response = await axios.delete(`${base_url}cms/menus/${id}`, config);
  return response.data;
};

const cmsMenusService = {
  getMenus,
  getMenu,
  getMenuByLocation,
  createMenu,
  updateMenu,
  deleteMenu,
};

export default cmsMenusService;

